"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Browse` instead */
export const Browse = createSVGIcon(
  <g clipPath="url(#clip0_5340_1279)" stroke="currentColor">
    <path
      d="M19.5 10.5h4M18.5 6.5h5M18.5 14.5h5M.75 11.057a8.126 8.126 0 1 0 16.251 0 8.126 8.126 0 0 0-16.251 0ZM20.25 22.432l-5.63-5.63"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>,
  "Browse",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
